/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Edit = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 16 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15.36 2.16L13.82.62a2.23 2.23 0 0 0-3.09 0l-9.8 9.82L0 16l5.55-.93 9.81-9.82a2.19 2.19 0 0 0 0-3.09zM2.72 10.81L9.8 3.73l2.46 2.46-7.07 7.08zm-.57 1.59l1.44 1.45-1.73.28zm12.13-8.24l-.94 1-2.46-2.52.94-.94a.65.65 0 0 1 .91 0l1.55 1.55a.63.63 0 0 1 0 .91z" />
      </g>
    </svg>
  </span>
);

Edit.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Edit.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Edit;
